import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentForRouteMangerPrintOption } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const resultData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const totalRow = this.props.total;

        return (
            <div>
                <h3 className="pr-2"><center><u>Route Manager Print Option Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <table
                    id="example"
                    className="display dataTable">
                    <thead>
                        <tr>
                            <th>Reg. Number</th>
                            <th>Is Master Card</th>
                            <th>Narration</th>
                            <th style={{ textAlign: "right" }}>Filed Gross Qunatity</th>
                            <th style={{ textAlign: "right" }}>Filed Net Qunatity</th>
                            <th style={{ textAlign: "right" }}>Field Tag Number</th>
                            <th style={{ textAlign: "right" }}>Factory Tag Number</th>
                            <th style={{ textAlign: "right" }}>Factory Gross Qunatity</th>
                            <th style={{ textAlign: "right" }}>Factory Net Qunatity</th>
                            <th style={{ textAlign: "right" }}>Loss/Gain</th>
                        </tr>
                    </thead>
                    <tbody>
                        <TableContentForRouteMangerPrintOption
                            data={resultData}
                            contentRowNames={contentRowNames}
                            hasEdit={false}
                        />
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colSpan={3}>Total</th>
                            <th style={{ textAlign: "right" }}>{totalRow.filedGross.toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{totalRow.fieldNetAmount.toFixed(2)}</th>
                            <th></th>
                            <th></th>
                            <th style={{ textAlign: "right" }}>{totalRow.factoryGrossAmount.toFixed(2)}</th>
                            <th style={{ textAlign: "right" }}>{totalRow.factoryGrossAmount.toFixed(2)}</th>
                            <th></th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
}